// extracted by mini-css-extract-plugin
module.exports = {"headingContainer":"Section_headingContainer__rjEKT","title":"Section_title__pVn_8","titleMobile":"Section_titleMobile__NhL9e","verticalSpacing":"Section_verticalSpacing__DysP0"};